import ParagraphBoundaryPreference from "models/audioEditor/ParagraphBoundaryPreference";
import SequencerOperationLog from "models/audioEditor/sequencerOperationLog/SequencerOperationLog";

const SequencerOperationChangeParagraphBoundaryPreferenceLog = SequencerOperationLog.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        SequencerOperationLog.apply(this, [attributes, options]);
    },

    getOperationName : function(){
        return "Change Paragraph Boundary";
    },

    setSequencerNodeCid : function(sequencerNodeCid){
        this.set("sequencerNodeCid", sequencerNodeCid);
    },

    getSequencerNodeCid : function(){
        return this.get("sequencerNodeCid");
    },

    setOldParagraphBoundaryPreference : function(paragraphBoundaryPreference){
        this.set(
            "oldParagraphBoundaryPreference",
            ParagraphBoundaryPreference.normalize(paragraphBoundaryPreference),
        );
    },

    getOldParagraphBoundaryPreference : function(){
        return this.get("oldParagraphBoundaryPreference") || null;
    },

    setNewParagraphBoundaryPreference : function(paragraphBoundaryPreference){
        this.set(
            "newParagraphBoundaryPreference",
            ParagraphBoundaryPreference.normalize(paragraphBoundaryPreference),
        );
    },

    getNewParagraphBoundaryPreference : function(){
        return this.get("newParagraphBoundaryPreference") || null;
    },
});

export default SequencerOperationChangeParagraphBoundaryPreferenceLog;
